module.exports = __webpack_public_path__ + "static/media/iconPaso3.191a1209.svg";